export default __webpack_public_path__ + "static/media/logo.04e02ea4.png";